import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type OfferSectionName =
    | "gallery"
    | "stages"
    | "key_details"
    | "promotions"
    | "properties"
    | "gethome_cross_promotion"
    | "map"
    | "public_transport"
    | "construction_photos"
    | "amenities"
    | "investment_details"
    | "current_offer"
    | "ranking"
    | "video"
    | "description"
    | "location"
    | "contact"
    | "recommended_offers"
    | "related_articles";

export type OfferViewSectionName = OfferSectionName;

interface ITrackAmplitudeOfferViewSectionParams {
    sectionName: OfferViewSectionName;
    itemId: number;
}

export const trackAmplitudeOfferViewSection = ({sectionName, itemId}: ITrackAmplitudeOfferViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: sectionName,
        location: "investment_page",
        item_id: itemId,
        property_id: null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type OfferSectionName =
    | "gallery"
    | "stages"
    | "key_details"
    | "promotions"
    | "properties"
    | "gethome_cross_promotion"
    | "map"
    | "public_transport"
    | "construction_photos"
    | "amenities"
    | "investment_details"
    | "current_offer"
    | "ranking"
    | "video"
    | "description"
    | "location"
    | "contact"
    | "recommended_offers"
    | "related_articles";

export type OfferViewSectionName = OfferSectionName;

interface ITrackAmplitudeOfferViewSectionParams {
    sectionName: OfferViewSectionName;
    itemId: number;
}

export const trackAmplitudeOfferViewSection = ({sectionName, itemId}: ITrackAmplitudeOfferViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: sectionName,
        location: "investment_page",
        item_id: itemId,
        property_id: null
    });
};
